export default "__VITE_ASSET__CPObazHD__"